import Index from './pages/Index';
import Podcast from './pages/Podcast'
import VueRouter from 'vue-router';

const routes = [
  {path: '/', name: 'index', component: Index},
  {path: '/episode/:id', name: 'podcast', component: Podcast}
];

export const VueRouterConfig = {
  mode: 'hash',
  routes: routes,
};

const router = new VueRouter(VueRouterConfig);

export default router;
